import Link from 'next/link'
import { Button, Table as T, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { CollapseBlock } from 'src/components/common/other/CollapseBlock'
import WithErrorBoundary from 'src/components/fallback/ErrorBoundaryV2'
import { HOMEWORK, URL_TEMPLATE } from 'src/libs/constant'
import { QuestionCircleOutlined } from '@ant-design/icons'

export function HomeworkInfo({ dataHomework, classData }) {
  const { t } = useTranslation()

  const arrayKeyDataHomework = Object.keys(dataHomework || []).filter((item) => dataHomework[item])
  const dataHomeworkConvert = arrayKeyDataHomework
    ?.map((item) => {
      if (item === HOMEWORK.quizExDTO) {
        return { ...dataHomework[item], type_question: HOMEWORK.quizExDTO, sessionId: dataHomework.sessionId }
      }
      if (item === HOMEWORK.speakingExDTO) {
        return {
          ...dataHomework[item],
          type_question: HOMEWORK.speakingExDTO,
          sessionId: dataHomework.sessionId,
        }
      }
    })
    .filter((item) => item)

  const columns = [
    {
      title: t('page.session.label.stt'),
      key: 'stt',
      dataIndex: 'stt',
      render(_, record, index) {
        return <>{index + 1}</>
      },
    },
    {
      title: t('page.session.label.type_of_exercise'),
      dataIndex: 'type_of_exercise',
      key: 'type_of_exercise',
      render(_, record) {
        const { type_question } = record || {}
        return <span>{t(`page.session.label.${type_question}`)}</span>
      },
    },
    {
      title: t('page.session.label.status_of_exercise'),
      dataIndex: 'status_of_exercise',
      key: 'status_of_exercise',
      render(_, record) {
        const { students } = record || {}
        return (
          <span>
            {t(`page.session.label.number_of_student_homework`, {
              number: `${students.length}/${classData?.students?.length}`,
            })}
          </span>
        )
      },
    },
    {
      title: t('page.session.label.action'),
      dataIndex: 'action',
      key: 'action',
      render(_, record) {
        const { sessionId, type_question } = record || {}
        const urlHomework =
          type_question === HOMEWORK.quizExDTO
            ? URL_TEMPLATE.SESSION_REGULAR_HOMEWORK
            : URL_TEMPLATE.SESSION_REGULAR_HOMEWORK_SPEAKING
        return (
          <Link href={`${urlHomework}?id=${sessionId}`}>
            <Button type='primary'>{t('page.session.label.view_exercises')}</Button>
          </Link>
        )
      },
    },
  ]

    return (
      <CollapseBlock header={
        <div className='d-inline-flex align-items-center'>
          <span>{t('page.session.label.homework_info')}</span>
          <Tooltip placement="bottomLeft" className='ml-2' title={t('page.session.label.not_data_homework')}>
            <QuestionCircleOutlined  style={{ fontSize: 17 }}/>
          </Tooltip>
        </div>
      }
      >
        <WithErrorBoundary boundaryTag='components.session.edit.HomeworkInfo'>
          <T
            dataSource={dataHomeworkConvert}
            columns={columns}
            pagination={false}
            rowKey='id'
            className='pb-3 lms-table-no-page'
          />
        </WithErrorBoundary>
      </CollapseBlock>
    )
  }
